module.exports = __webpack_public_path__ + "img/diw_16_Debt.8e81f33c.png";